export class ClientFilterProperties {
  public readonly property: string;
  public readonly value: any;
  public readonly operator: string;

  constructor(property: string, value: any, operator?: string) {
    Object.assign(this, {property, value, operator});
  }
}
